import React, {FC, useEffect, useState} from 'react';

import {Icon, Pdf} from '@optimaxdev/icons';

import {PrescriptionType} from 'desktop/types/checkoutItemsType';
import {apiConfig} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';
import {getMimeTypeFromBase64} from 'libs/utils/utils';

import style from './prescriptionUploaded.scss';

export type PropsType = {
    prescription: PrescriptionType;
};

/**
 * Prescription image/pdf uploaded show block
 * @returns {React.ReactElement}
 */
export const PrescriptionUploaded: FC<PropsType> = ({prescription}): React.ReactElement => {
    const [src, setSrc] = useState('');
    const [isPDFExtension, setIsPDFExtension] = useState(false);

    useEffect(() => {
        try {
            apiConfig
                .instanceGusaBackend(prescription.link as string, {
                    baseURL: '',
                    responseType: 'blob',
                })
                .then(response => {
                    const imgUrl = URL.createObjectURL(response.data);
                    setSrc(imgUrl);
                    const reader = new FileReader();
                    reader.onload = () => {
                        const base64data = reader.result as string;
                        if (getMimeTypeFromBase64(base64data) === 'application/pdf') {
                            setIsPDFExtension(true);
                        }
                    };
                    reader.readAsDataURL(response.data);
                });
        } catch (e) {
            logWithSentry(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div aria-label="prescription upload block" className={style.prescriptionImgBlock}>
            {isPDFExtension ? (
                <div className={style.pdfWrapper}>
                    <div aria-label="pdf-icon" className={style.iconFile}>
                        <Icon icon={Pdf} />
                    </div>
                    <p className={style.pdfName}>{prescription.name}</p>
                </div>
            ) : (
                <div className={style.prescriptionImgWrapper}>
                    {/* eslint-disable-next-line react/forbid-elements */}
                    <img alt="prescription" className={style.prescriptionImg} src={src} />
                    <div className={style.gradient} />
                    <p className={style.imageName}>{prescription.name}</p>
                </div>
            )}
        </div>
    );
};
